import { getRegionlessLanguage } from '~/utils/getRegionlessLanguage';

export const initializeSearch = async (locale: string): Promise<void> => {
  if (
    !process.env.GATSBY_ELASTICSEARCH_ENGINE &&
    !process.env.GATSBY_ALGOLIA_INDEX
  ) {
    const pagefind = await import('static/pagefind/pagefind');

    await pagefind.options({
      basePath: `${window.location.origin}/pagefind/`,
      language: getRegionlessLanguage(locale),
    });
    await pagefind.init();
  }
};
